import React, {FC} from 'react';
import {GxDropdown, GxMenu} from '@garpix/garpix-web-components-react';
import cnBind from 'classnames/bind';

import {NAME_STATUS, TYPES_STATUS} from '../../consts';

import styles from './styles/index.module.scss';
import {ICustomCSSUserCard} from '../../interfaces';

interface IUserCard {
  data: Record<string, any>;
  index: number;
  openModalOrder: ( data: Record<string, any>) => void;
}

const UserCard: FC<IUserCard> = (props) => {
  const { data, index, openModalOrder } = props;
  const { rate_name, price, tariff_name } = data.tariff_rate;

  const cn = cnBind.bind(styles);

  const open = () =>{
    openModalOrder(data)
  }

  return (
    <>
      <div
        className={styles['wrapper']}
        onClick={open}
        role='button'
        tabIndex={0}
        style={
          {
            '--tariff-color': data.tariff.color_code,
          } as ICustomCSSUserCard
        }
      >
        <GxDropdown
          placement={index !== 0 ? 'left-start' : 'right'}
          className={styles['dropdown']}
          open
          hoist
        >
          <div className={styles['dropdown--trigger']} slot='trigger' />
          <GxMenu className={styles['dropdown--menu']}>
            <div className={styles['dropdown--menu-header']}>10-20 мин.</div>
            <div className={styles['dropdown--menu-main']}>
              <div className={styles['item']}>
                <span className={styles['item--title']}>Название</span>
                <span className={styles['item--name']}>{rate_name}</span>
              </div>
              <div className={styles['item']}>
                <span className={styles['item--title']}>Тариф</span>
                <span className={styles['item--name']}>{tariff_name}</span>
              </div>
              <div className={styles['item']}>
                <span className={styles['item--title']}>Стоимость</span>
                <span className={styles['item--price']}>{price}</span>
              </div>
            </div>
          </GxMenu>
        </GxDropdown>
        <div className={styles['user-card']} key={data.id}>
          <h2 className={styles['user-card__title']}>{rate_name}</h2>
          <p
            className={styles['user-card__username']}
          >{`${data.customer.last_name} ${data.customer.first_name}`}</p>
          <span
            className={cn(
              styles['body-row__status'],
              styles[
                `body-row__status--${
                  NAME_STATUS[TYPES_STATUS[data.status]].class
                }`
              ]
            )}
          >
            {NAME_STATUS[TYPES_STATUS[data.status]].title}
          </span>
        </div>
      </div>
    </>
  );
};

export default UserCard;
